document.addEventListener('DOMContentLoaded', () => {
  const mountStandaloneMegaMenus = () => {
    document.querySelectorAll('[data-standalone-mega-menu-source]').forEach(source => {
      if (source.dataset.hasLinks !== 'true') return;

      const menuKey = source.dataset.standaloneMegaMenuSource;
      const desktopContent = source.querySelector('[data-standalone-mega-desktop]');
      const mobileContent = source.querySelector('[data-standalone-mega-mobile]');
      const desktopTarget = document.querySelector(`[data-mega-menu-target="${menuKey}"]`);
      const mobileTarget = document.querySelector(`[data-mobile-mega-menu-target="${menuKey}"]`);

      if (desktopContent && desktopTarget && desktopContent.parentElement !== desktopTarget) {
        desktopTarget.replaceChildren(desktopContent);
      }
      if (mobileContent && mobileTarget && mobileContent.parentElement !== mobileTarget) {
        mobileTarget.replaceChildren(...mobileContent.children);
      }
    });
  };

  mountStandaloneMegaMenus();
  document.addEventListener('shopify:section:load', mountStandaloneMegaMenus);

  const updateHeaderBottom = () => {
    const headerGroup = document.querySelector('.site-header-group');
    if (!headerGroup) return;
    const headerHeight = Math.ceil(headerGroup.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-bottom', `${headerHeight}px`);
  };
  updateHeaderBottom();
  window.addEventListener('resize', updateHeaderBottom, { passive: true });
  window.addEventListener('orientationchange', updateHeaderBottom, { passive: true });
  window.addEventListener('pageshow', updateHeaderBottom, { passive: true });
  window.visualViewport?.addEventListener('resize', updateHeaderBottom, { passive: true });
  const headerResizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver(updateHeaderBottom)
    : null;
  headerResizeObserver?.observe(document.querySelector('.site-header-group'));
  document.fonts?.ready.then(updateHeaderBottom);

  document.querySelectorAll('[data-product-fomo]').forEach(fomo => {
    const count = fomo.querySelector('[data-fomo-count]');
    if (!count) return;

    const configuredMin = Number.parseInt(fomo.dataset.minViewers, 10) || 1;
    const configuredMax = Number.parseInt(fomo.dataset.maxViewers, 10) || configuredMin;
    const min = Math.min(configuredMin, configuredMax);
    const max = Math.max(configuredMin, configuredMax);
    const range = max - min + 1;
    const storageKey = `cli-fomo-${fomo.dataset.productId || 'product'}`;
    const previous = Number.parseInt(window.sessionStorage.getItem(storageKey), 10);
    let next = min + Math.floor(Math.random() * range);

    if (range > 1 && next === previous) {
      next = min + ((next - min + 1) % range);
    }

    count.textContent = String(next);
    window.sessionStorage.setItem(storageKey, String(next));
  });

  // Mobile menu
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    const openMobileMenu = () => {
      mobileMenu.classList.add('active');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mobile-menu-open');
    };
    const closeMobileMenu = () => {
      mobileMenu.classList.remove('active');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');
    };

    menuToggle.addEventListener('click', openMobileMenu);
    mobileMenu.querySelector('.mobile-menu__close').addEventListener('click', closeMobileMenu);
    mobileMenu.querySelector('.mobile-menu__overlay').addEventListener('click', closeMobileMenu);

    mobileMenu.querySelectorAll('.mobile-menu__toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('.mobile-menu__item--has-children');
        const isOpen = item?.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  // Header search toggle on mobile (optional expansion)
  const headerSearch = document.querySelector('.header__search');
  if (headerSearch) {
    headerSearch.addEventListener('focusin', () => headerSearch.classList.add('is-active'));
  }

  // Expert consultation modal
  const expertModal = document.getElementById('ExpertModal');
  const expertOpenButtons = document.querySelectorAll('[data-expert-open]');
  const expertCloseButtons = document.querySelectorAll('[data-expert-close]');
  if (expertModal && expertOpenButtons.length) {
    const openExpertModal = () => {
      expertModal.classList.add('active');
      expertModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
    };

    const closeExpertModal = () => {
      expertModal.classList.remove('active');
      expertModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
    };

    expertOpenButtons.forEach(button => {
      button.addEventListener('click', openExpertModal);
    });
    expertCloseButtons.forEach(button => {
      button.addEventListener('click', closeExpertModal);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && expertModal.classList.contains('active')) {
        closeExpertModal();
      }
    });
  }

  // Hero parallax
  const heroBg = document.querySelector('.hero__bg');
  if (heroBg) {
    const updateParallax = () => {
      const scrollY = window.scrollY;
      const heroHeight = heroBg.parentElement.offsetHeight;
      if (scrollY <= heroHeight) {
        heroBg.style.transform = `translateY(${scrollY * 0.35}px) scale(1.08)`;
      }
    };
    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  }

  const motionHero = document.querySelector('[data-motion-hero]');
  if (motionHero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let pointerX = 0;
    let pointerY = 0;
    let scrollValue = 0;
    let ticking = false;

    const updateMotionHero = () => {
      motionHero.style.setProperty('--hero-x', pointerX.toFixed(3));
      motionHero.style.setProperty('--hero-y', pointerY.toFixed(3));
      motionHero.style.setProperty('--hero-scroll', scrollValue.toFixed(2));
      ticking = false;
    };

    const requestMotionHeroUpdate = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateMotionHero);
        ticking = true;
      }
    };

    const updatePointer = (event) => {
      const rect = motionHero.getBoundingClientRect();
      pointerX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      pointerY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      requestMotionHeroUpdate();
    };

    const updateScroll = () => {
      const rect = motionHero.getBoundingClientRect();
      scrollValue = Math.max(-1, Math.min(1, rect.top / Math.max(1, rect.height)));
      requestMotionHeroUpdate();
    };

    motionHero.addEventListener('pointermove', updatePointer, { passive: true });
    motionHero.addEventListener('pointerleave', () => {
      pointerX = 0;
      pointerY = 0;
      requestMotionHeroUpdate();
    });
    window.addEventListener('scroll', updateScroll, { passive: true });
    updateScroll();
  }

  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
    if (slides.length <= 1) return;

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const interval = Math.max(1000, parseInt(slider.dataset.interval, 10) || 5000);
    let activeIndex = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer = null;

    const getDirection = (currentIndex, nextIndex) => {
      if (nextIndex === currentIndex) return 0;
      if (currentIndex === slides.length - 1 && nextIndex === 0) return 1;
      if (currentIndex === 0 && nextIndex === slides.length - 1) return -1;
      return nextIndex > currentIndex ? 1 : -1;
    };

    const setSlidePositions = () => {
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === activeIndex);
        slide.classList.toggle('is-before', index < activeIndex);
        slide.classList.toggle('is-after', index > activeIndex);
        slide.classList.remove('is-leaving-left', 'is-leaving-right', 'is-entering');
      });
    };

    const showSlide = (nextIndex) => {
      const requestedIndex = (nextIndex + slides.length) % slides.length;
      const direction = getDirection(activeIndex, requestedIndex);
      if (!direction) return;

      const previousSlide = slides[activeIndex];
      const nextSlide = slides[requestedIndex];
      previousSlide.classList.remove('is-active', 'is-before', 'is-after', 'is-leaving-left', 'is-leaving-right', 'is-entering');
      previousSlide.classList.add(direction > 0 ? 'is-leaving-left' : 'is-leaving-right');

      nextSlide.classList.remove('is-before', 'is-after', 'is-leaving-left', 'is-leaving-right');
      nextSlide.classList.add('is-active', 'is-entering');

      activeIndex = requestedIndex;
      const activeSlideId = slides[activeIndex].dataset.slideId;

      slides.forEach((slide, index) => {
        if (slide === previousSlide || slide === nextSlide) return;
        slide.classList.toggle('is-before', index < activeIndex);
        slide.classList.toggle('is-after', index > activeIndex);
        slide.classList.remove('is-active', 'is-leaving-left', 'is-leaving-right', 'is-entering');
      });
      dots.forEach(dot => {
        dot.classList.toggle('is-active', dot.dataset.slideId === activeSlideId);
      });

      window.setTimeout(setSlidePositions, 780);
    };

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      if (!autoplayEnabled) return;
      timer = setInterval(() => showSlide(activeIndex + 1), interval);
    };

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const requestedIndex = slides.findIndex(slide => slide.dataset.slideId === dot.dataset.slideId);
        if (requestedIndex < 0) return;
        stopAutoplay();
        showSlide(requestedIndex);
      });
    });

    setSlidePositions();
    startAutoplay();
  });

  // Keep editable homepage copy inside its cards/sections when merchants add longer text.
  if (document.body.classList.contains('template-index')) {
    const textFitSelector = [
      '.section-title',
      '.hero__title',
      '.hero__subtitle',
      '.hero-slider__actions .button',
      '.category-card__title',
      '.collection-card__title',
      '.market-tile__copy span',
      '.market-tile__copy strong',
      '.market-tile__copy small',
      '.brand-range-spotlight__header p',
      '.brand-range-card__copy span',
      '.brand-range-card__copy strong',
      '.brand-range-card__copy small',
      '.brand-range-card__copy b',
      '.trust-badge h3',
      '.trust-badge p',
      '.promo-banner__title',
      '.promo-banner__text',
      '.review-card__name',
      '.review-card__text',
      '.reviews-summary__text',
      '.marquee-review__text',
      '.marquee-review__author',
      '.fortinet-catalogue__subtitle',
      '.fortinet-card__title',
      '.fortinet-card__list li',
      '.homepage-full-video__copy h2',
      '.homepage-full-video__copy p',
      '.closing-showcase__layout h2',
      '.closing-showcase__layout h3',
      '.closing-showcase__layout p'
    ].join(',');
    const observedTextFitBoxes = new WeakSet();
    let textFitFrame = null;

    const getTextFitMin = (baseSize) => {
      if (baseSize >= 44) return 16;
      if (baseSize >= 28) return 14;
      if (baseSize >= 18) return 12;
      return 11;
    };

    const elementOverflows = (element) => (
      element.scrollWidth > element.clientWidth + 1 ||
      element.scrollHeight > element.clientHeight + 1
    );

    const textFitContainer = (element) => element.closest([
      '.brand-range-card',
      '.market-tile',
      '.category-card',
      '.collection-card',
      '.promo-banner',
      '.review-card',
      '.marquee-review',
      '.trust-badge',
      '.fortinet-card',
      '.homepage-full-video__copy',
      '.closing-showcase__layout',
      '.section-header',
      '.brand-range-spotlight__header',
      '.marketplace-showcase__header'
    ].join(','));

    const boxOverflows = (box) => (
      box &&
      box.clientWidth > 0 &&
      box.clientHeight > 0 &&
      (
        box.scrollWidth > box.clientWidth + 1 ||
        box.scrollHeight > box.clientHeight + 1
      )
    );

    const fitTextElement = (element) => {
      if (!element.isConnected || element.offsetParent === null) return;
      const computed = window.getComputedStyle(element);
      const baseSize = parseFloat(element.dataset.autoFitBaseSize || computed.fontSize);
      if (!baseSize || element.clientWidth <= 0) return;

      element.dataset.autoFitBaseSize = String(baseSize);
      const fitBox = textFitContainer(element);
      const fitSignature = [
        element.textContent.trim(),
        Math.round(element.clientWidth),
        Math.round(fitBox?.clientWidth || 0),
        Math.round(fitBox?.clientHeight || 0)
      ].join('|');

      // Font-size changes trigger ResizeObserver too. Avoid resetting a fitted
      // element to its large base size when its text and available space did not change.
      if (element.dataset.autoFitSignature === fitSignature && element.style.fontSize) return;

      element.dataset.autoFitSignature = fitSignature;
      element.style.fontSize = `${baseSize}px`;

      let nextSize = baseSize;
      const minSize = getTextFitMin(baseSize);
      while (nextSize > minSize && (elementOverflows(element) || boxOverflows(fitBox))) {
        nextSize -= 1;
        element.style.fontSize = `${nextSize}px`;
      }
    };

    const fitHomepageText = () => {
      textFitFrame = null;
      document.querySelectorAll(textFitSelector).forEach(fitTextElement);
    };

    const scheduleHomepageTextFit = () => {
      if (textFitFrame) return;
      textFitFrame = window.requestAnimationFrame(fitHomepageText);
    };

    const textFitObserver = 'ResizeObserver' in window
      ? new ResizeObserver(scheduleHomepageTextFit)
      : null;

    const observeHomepageText = () => {
      document.querySelectorAll(textFitSelector).forEach(element => {
        element.setAttribute('data-auto-fit-text', '');
        const fitBox = textFitContainer(element) || element.parentElement;
        if (textFitObserver && fitBox && !observedTextFitBoxes.has(fitBox)) {
          observedTextFitBoxes.add(fitBox);
          textFitObserver.observe(fitBox);
        }
      });
      scheduleHomepageTextFit();
    };

    const textContentObserver = 'MutationObserver' in window
      ? new MutationObserver(observeHomepageText)
      : null;

    observeHomepageText();
    if (textContentObserver) {
      textContentObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    window.addEventListener('resize', scheduleHomepageTextFit, { passive: true });
    document.addEventListener('shopify:section:load', observeHomepageText);
    document.addEventListener('shopify:section:select', observeHomepageText);
    document.addEventListener('shopify:block:deselect', scheduleHomepageTextFit);
    document.addEventListener('shopify:block:select', scheduleHomepageTextFit);
    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleHomepageTextFit);
    }
  }

  document.querySelectorAll('.reviews-grid--marquee, .reviews-marquee').forEach(scroller => {
    let startX = 0;
    let scrollStart = 0;
    let isDragging = false;

    const stopTrackAnimation = () => {
      scroller.classList.add('is-user-controlled');
      scroller.querySelectorAll('.reviews-grid__track, .reviews-marquee__track').forEach(track => {
        track.style.animationPlayState = 'paused';
      });
    };

    scroller.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      isDragging = true;
      startX = event.clientX;
      scrollStart = scroller.scrollLeft;
      stopTrackAnimation();
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture?.(event.pointerId);
    });

    scroller.addEventListener('pointermove', event => {
      if (!isDragging) return;
      scroller.scrollLeft = scrollStart - (event.clientX - startX);
    });

    const endDrag = event => {
      if (!isDragging) return;
      isDragging = false;
      scroller.classList.remove('is-dragging');
      scroller.releasePointerCapture?.(event.pointerId);
    };

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('wheel', stopTrackAnimation, { passive: true });
    scroller.addEventListener('touchstart', stopTrackAnimation, { passive: true });
  });

  // Scroll-triggered fade animations
  const animatedElements = document.querySelectorAll('[data-animate]');
  if (animatedElements.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    animatedElements.forEach(el => observer.observe(el));
  }
});

// Cart notification helper
window.showCartNotification = function () {
  const notification = document.getElementById('cart-notification');
  if (notification) {
    notification.classList.remove('hidden');
    setTimeout(() => notification.classList.add('hidden'), 3000);
  }
};

// Simple AJAX add to cart helper
async function addItemToCart(formData) {
  const res = await fetch(`${window.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams(formData).toString()
  });
  if (!res.ok) throw new Error('Add to cart failed');
  return res.json();
}

window.addItemToCart = addItemToCart;
